export default "__VITE_ASSET__718eaf07__"